/*
  F&NT · Tracking del cliente (v14, 29–30 sep 2026 · v18, 9 oct 2026 · v19, 10 oct 2026)
  1) Llegada: primera (30 días) y última (visita): fuente | medio | campaña | contenido | landing | dispositivo.
  2) Recorrido: últimas fichas (p:), colecciones (c:), búsquedas (s:, también desde el buscador predictivo) y quiz.
  3) Origen de cada producto agregado: propiedad de línea _origen
     (ficha, ficha-sugeridos, barra-fija, upsell-carrito, listado, busqueda, recomendados, quiz, blog, otro).
     Si el producto ya estaba en el carrito se reutiliza su primer origen (no se parte en dos renglones).
  4) Al agregar y al ir al checkout guarda llegada y recorrido en los atributos del carrito (llegan al pedido).
  30 sep: resultados de búsqueda (sección fnt_busqueda / plantilla search) = busqueda.
          Predictivo: se guarda lo escrito; si la ficha abre con _ss=r (enlace del predictivo de Shopify) se suma s: al recorrido.
  9 oct (v18): la visita ya no es por pestaña (sessionStorage) sino por inactividad: termina tras 30 min sin
          actividad, en cualquier pestaña (localStorage). _minutos_desde_llegada cuenta desde el inicio de la visita.
          Antes, abrir la tienda en otra pestaña reiniciaba la última llegada y el contador (#1085: 5 min en vez de ~23).
  10 oct (v19): _llegada_primera termina con fecha y hora de México (AAAA-MM-DD HH:MM). Antes era solo la fecha
          en UTC: un pedido de noche aparecía con el día siguiente (#1086: 9 oct 23:50 salía como 2026-10-10).
  10 oct (v19): los regresos desde pasos internos (login de cuenta en shopify.com, Shop Pay en shop.app, PayPal,
          Mercado Pago, myshopify.com o el propio dominio) no cuentan como llegada: si no traen UTM ni identificador
          de campaña, la última llegada se conserva (#1089 quedó como "shopify.com | referencia").
  Sin datos personales. Estándar: FNT_medicion §3. Respaldos: assets/respaldo-fnt-tracking-2026-10-10.txt (v18)
  y assets/respaldo-fnt-tracking-2026-10-10-v19.txt (v19 antes de los pasos internos)
*/
(function () {
  'use strict';
  if (window.__fntTracking) return;
  window.__fntTracking = true;

  var LS = window.localStorage, SS = window.sessionStorage;
  var K_FIRST = 'fnt_llegada_primera', K_LAST = 'fnt_llegada_ultima', K_REC = 'fnt_recorrido', K_ORIG = 'fnt_origenes', K_Q = 'fnt_busqueda_predictiva';
  var K_VISITA = 'fnt_visita';
  var DIAS30 = 30 * 864e5;
  var INACTIVA = 30 * 60000;
  var now = Date.now();

  function get(s, k) { try { return JSON.parse(s.getItem(k) || 'null'); } catch (e) { return null; } }
  function set(s, k, v) { try { s.setItem(k, JSON.stringify(v)); } catch (e) {} }

  var params;
  try { params = new URLSearchParams(location.search); } catch (e) { params = { get: function () { return null; } }; }

  // ---------- 0. Visita (compartida entre pestañas, termina tras 30 min sin actividad) ----------
  var visita = get(LS, K_VISITA);
  var visitaNueva = !visita || !visita.t0 || now - (visita.u || 0) > INACTIVA;
  if (visitaNueva) visita = { t0: now, u: now };
  else visita.u = now;
  set(LS, K_VISITA, visita);
  function tocarVisita() {
    var v = get(LS, K_VISITA), t = Date.now();
    if (!v || !v.t0 || t - (v.u || 0) > INACTIVA) v = { t0: t, u: t };
    else v.u = t;
    set(LS, K_VISITA, v);
    return v;
  }

  // ---------- 1. Llegada ----------
  function dispositivo() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet/i.test(ua)) return 'tableta';
    if (/Mobi|Android|iPhone/i.test(ua)) return 'celular';
    return 'computadora';
  }
  function referente() {
    try {
      if (!document.referrer) return '';
      var h = new URL(document.referrer).hostname.replace(/^www\./, '');
      return h === location.hostname.replace(/^www\./, '') ? '' : h;
    } catch (e) { return ''; }
  }
  // Pasos por los que el cliente pasa sin salir de la tienda: login de cuentas, Shop Pay, pagos y dominios propios.
  var PASOS_INTERNOS = /(^|\.)(shopify\.com|shop\.app|myshopify\.com|paypal\.com|mercadopago\.com(\.mx)?|fntsuplementos\.com)$/i;
  function esPasoInterno(ref) { return !!ref && PASOS_INTERNOS.test(ref); }

  // Un clic de campaña (UTM o identificador de Google/Meta) actualiza la última llegada aunque la visita siga;
  // el inicio de la visita (t0) no cambia.
  var tieneCampana = !!(params.get('utm_source') || params.get('gclid') || params.get('gbraid') || params.get('wbraid') || params.get('fbclid') || params.get('srsltid'));
  var refActual = referente();
  var regresoInterno = !tieneCampana && esPasoInterno(refActual);

  if ((visitaNueva && !regresoInterno) || tieneCampana || !get(LS, K_LAST)) {
    var ref = esPasoInterno(refActual) ? '' : refActual;
    var f = params.get('utm_source'), m = params.get('utm_medium');
    if (!f) {
      if (params.get('gclid') || params.get('gbraid') || params.get('wbraid')) { f = 'google'; m = 'cpc'; }
      else if (params.get('fbclid')) { f = ref || 'meta'; m = 'social'; }
      else if (params.get('srsltid')) { f = 'google'; m = 'merchant-center'; }
      else if (ref) { f = ref; m = /google|bing|yahoo|duckduckgo|ecosia/.test(ref) ? 'organico' : 'referencia'; }
      else { f = 'directo'; m = '-'; }
    }
    var llegada = {
      f: f, m: m || '-',
      c: params.get('utm_campaign') || '-',
      ct: params.get('utm_content') || '-',
      lp: location.pathname.slice(0, 80),
      d: dispositivo(),
      t: now
    };
    set(LS, K_LAST, llegada);
    var primera = get(LS, K_FIRST);
    if (!primera || now - primera.t > DIAS30) set(LS, K_FIRST, llegada);
  }

  // ---------- 2. Recorrido ----------
  function agregarPaso(e) {
    if (!e) return;
    var t = Date.now();
    var r = (get(LS, K_REC) || []).filter(function (i) { return t - i[1] < DIAS30; });
    var ult = r[r.length - 1];
    if (!ult || ult[0] !== e) r.push([e, t]);
    set(LS, K_REC, r.slice(-25));
  }
  (function () {
    var path = location.pathname, x, e = null;
    if ((x = path.match(/\/products\/([^\/?#]+)/))) {
      // Llegó desde el buscador predictivo: primero la búsqueda, luego la ficha
      var pq = get(SS, K_Q);
      if (params.get('_ss') === 'r' && pq && pq.q && now - pq.t < 30 * 60000) agregarPaso('s:' + pq.q);
      e = 'p:' + x[1];
    }
    else if ((x = path.match(/\/collections\/([^\/?#]+)/))) e = 'c:' + x[1];
    else if (path.indexOf('/search') === 0 && params.get('q')) e = 's:' + String(params.get('q')).slice(0, 30);
    else if (path.indexOf('/pages/quiz') === 0) e = 'quiz';
    else if (path.indexOf('/blogs/') === 0) e = 'blog';
    agregarPaso(e);
  })();

  // Buscador predictivo: se guarda lo que escribe el cliente (se usa si abre una ficha con _ss=r)
  var SEL_PREDICTIVO = 'predictive-search-component, .predictive-search, search-modal, [id*="predictive" i]';
  document.addEventListener('input', function (ev) {
    var t = ev.target;
    if (!t || !t.matches || !t.matches('input[type="search"], input[name="q"]')) return;
    var q = String(t.value || '').trim();
    if (q.length > 1) set(SS, K_Q, { q: q.slice(0, 30), t: Date.now() });
  }, true);

  // ---------- 3. Origen del agregado ----------
  var ultimoEl = null, ultimoT = 0;
  document.addEventListener('click', function (ev) { ultimoEl = ev.target; ultimoT = Date.now(); }, true);

  function plantilla() {
    var main = document.getElementById('MainContent');
    return (main && main.getAttribute('data-template')) || '';
  }

  function origenDe(el) {
    if (!el || !el.closest) return 'otro';
    if (el.closest('fnt-sticky-atc')) return 'barra-fija';
    if (el.closest('cart-drawer-component, .cart-drawer, .fnt-up')) return 'upsell-carrito';
    if (el.closest(SEL_PREDICTIVO)) return 'busqueda';
    var sec = el.closest('[id^="shopify-section-"]');
    var sid = sec ? sec.id.toLowerCase() : '';
    if (/quiz/.test(sid)) return 'quiz';
    if (/recomend|recommendation|related/.test(sid)) return 'recomendados';
    if (/search|busqueda/.test(sid) || /^search/.test(plantilla())) return 'busqueda';
    if (/article|blog/.test(sid)) return 'blog';
    if (/__main/.test(sid) && /^product/.test(plantilla())) {
      return el.closest('.fnt-card, product-card, [class*="product-card"]') ? 'ficha-sugeridos' : 'ficha';
    }
    return 'listado';
  }

  function origenActual() {
    return Date.now() - ultimoT < 5000 ? origenDe(ultimoEl) : 'otro';
  }

  function mapa() { return get(SS, K_ORIG) || {}; }
  function origenPara(id, porDefecto) {
    var mp = mapa(), k = String(id || '');
    if (k && mp[k]) return mp[k];
    if (k) { mp[k] = porDefecto; set(SS, K_ORIG, mp); }
    return porDefecto;
  }
  function recordar(id, o) {
    var mp = mapa(), k = String(id || '');
    if (k && !mp[k]) { mp[k] = o; set(SS, K_ORIG, mp); }
  }

  function conOrigen(body, o) {
    // JSON
    if (typeof body === 'string' && /^\s*\{/.test(body)) {
      try {
        var data = JSON.parse(body);
        var items = Array.isArray(data.items) ? data.items : [data];
        items.forEach(function (it) {
          if (!it || !it.id) return;
          it.properties = it.properties || {};
          if (it.properties._origen) recordar(it.id, it.properties._origen);
          else it.properties._origen = origenPara(it.id, o);
        });
        return JSON.stringify(data);
      } catch (e) { return body; }
    }
    // FormData
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var id = body.get('id');
      if (body.has('properties[_origen]')) recordar(id, body.get('properties[_origen]'));
      else body.append('properties[_origen]', origenPara(id, o));
      return body;
    }
    // URLSearchParams o texto urlencoded
    try {
      var usp = body instanceof URLSearchParams ? body : (typeof body === 'string' ? new URLSearchParams(body) : null);
      if (usp) {
        var vid = usp.get('id');
        if (usp.has('properties[_origen]')) recordar(vid, usp.get('properties[_origen]'));
        else usp.append('properties[_origen]', origenPara(vid, o));
        return typeof body === 'string' ? usp.toString() : usp;
      }
    } catch (e) {}
    return body;
  }

  // Formularios clásicos a /cart/add: se agrega el campo antes de que el tema arme su envío
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.action || !/\/cart\/add/.test(form.action)) return;
    if (form.querySelector('[name="properties[_origen]"]')) return;
    var idEl = form.querySelector('[name="id"]');
    var o = origenPara(idEl && idEl.value, ev.submitter ? origenDe(ev.submitter) : origenActual());
    var input = document.createElement('input');
    input.type = 'hidden'; input.name = 'properties[_origen]'; input.value = o;
    form.appendChild(input);
  }, true);

  // ---------- 4. Atributos del carrito ----------
  var fetchOriginal = window.fetch;

  function fmt(l) {
    if (!l || !l.f) return '';
    return [l.f, l.m, l.c, l.ct, l.lp, l.d].join(' | ');
  }
  // Fecha y hora de México (AAAA-MM-DD HH:MM). Si el navegador no tiene zonas horarias, UTC marcado.
  function fechaMx(t) {
    try {
      return new Date(t).toLocaleString('sv-SE', { timeZone: 'America/Mexico_City', hour12: false }).slice(0, 16);
    } catch (e) {
      return new Date(t).toISOString().slice(0, 16).replace('T', ' ') + ' UTC';
    }
  }
  function atributos() {
    var v = tocarVisita();
    var p = get(LS, K_FIRST), u = get(LS, K_LAST), r = get(LS, K_REC) || [];
    var t0 = (v && v.t0) || (u && u.t) || now;
    return {
      '_llegada_primera': fmt(p) + (p && p.t ? ' | ' + fechaMx(p.t) : ''),
      '_llegada_ultima': fmt(u),
      '_recorrido': r.map(function (i) { return i[0]; }).join(' > ').slice(-450),
      '_minutos_desde_llegada': String(Math.max(0, Math.round((Date.now() - t0) / 60000)))
    };
  }
  var espera = null;
  function guardarAtributos(inmediato) {
    function enviar() {
      try {
        fetchOriginal.call(window, '/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: atributos() }),
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
    clearTimeout(espera);
    if (inmediato) enviar(); else espera = setTimeout(enviar, 400);
  }

  if (typeof fetchOriginal === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
          var nuevo = Object.assign({}, init);
          nuevo.body = conOrigen(init.body, origenActual());
          return fetchOriginal.call(this, input, nuevo).then(function (res) {
            if (res && res.ok) guardarAtributos(false);
            return res;
          });
        }
      } catch (e) {}
      return fetchOriginal.apply(this, arguments);
    };
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('[name="checkout"], a[href*="/checkout"], button[form*="cart"][name="checkout"]')) {
      guardarAtributos(true);
    }
  }, true);
})();